import { Button, ButtonProps } from "antd";

interface PrimaryButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export const PrimaryButton = ({
  children,
  style,
  type = "primary",
  ...props
}: PrimaryButtonProps) => {
  return (
    <Button
      type={type}
      size="middle"
      style={{
        boxShadow: "none",
        opacity: 1, // Ensure visibility
        ...style,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
